import { render } from "./jinniao.vue?vue&type=template&id=4e69f23e&scoped=true"
import script from "./jinniao.vue?vue&type=script&lang=js"
export * from "./jinniao.vue?vue&type=script&lang=js"

import "./jinniao.vue?vue&type=style&index=0&id=4e69f23e&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e69f23e"]])

export default __exports__